import { TreeItem } from '@dealstack/frontend/shared/components/Tree/utils';
import { TreeItemComponent } from '@dealstack/frontend/shared/components/Tree/TagTreeItemComponent';
import { Flex } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	items: TreeItem[];
	onItemClick?: (item: TreeItem) => void;
	onSelectionChange?: (selectedIds: string[]) => void;
	onExpandChange?: (expandedIds: string[]) => void;
}

export const Tree = ({ items, onItemClick, onSelectionChange, onExpandChange }: Props) => {
	const renderedItems = items.map((item) => (
		<TreeItemComponent
			key={item.id}
			item={item}
			onItemClick={onItemClick}
			onSelectionChange={onSelectionChange}
			onExpandChange={onExpandChange}
			nestingLevel={0}
		/>
	));

	return (
		<Flex data-testid={TEST_ELEMENT_IDS.TREE} direction="column" w="100%">
			{renderedItems}
		</Flex>
	);
};
